// import React, { useEffect } from 'react'
// import { Edit, Trash, X } from 'lucide-react'; // Icons for edit and delete
// import { useDispatch } from 'react-redux';
// import { deleteCompany } from '../../../FeatureRedux/CompanyReducer/deleteCompany'
// import { allcompanylist } from '../../../FeatureRedux/CompanyReducer/getCompanylist'


// function CompanyDeleteButton({ id }) {
//   const dispatch = useDispatch();

//   const handledelete = async () => {
//     await dispatch(deleteCompany(id))
//     dispatch(allcompanylist())
//   }

//   //  useEffect(()=>{
//   //   dispatch(allcompanylist())
//   // dispatch(deleteCompany(id))
//   //  },[])

//   return (
//     <div>
//       <button
//         onClick={() => handledelete()}
//         className="text-red-500 hover:text-red-600"
//       >
//         <Trash size={16} />
//       </button>
//     </div>
//   )
// }

// export default CompanyDeleteButton;






// karan edited code start here 
// import React, { useState } from 'react'
// import { Edit, Trash, X } from 'lucide-react'; // Icons for edit and delete
// import { useDispatch } from 'react-redux';
// import { deleteCompany } from '../../../FeatureRedux/CompanyReducer/deleteCompany'
// import { allcompanylist } from '../../../FeatureRedux/CompanyReducer/getCompanylist'


// function CompanyDeleteButton({ id }) {
//   const dispatch = useDispatch();
//   const [showConfirmation, setShowConfirmation] = useState(false);

//   const handledelete = async () => {
//     await dispatch(deleteCompany(id))
//     dispatch(allcompanylist())
//     setShowConfirmation(false)
//   }

//   return (
//     <div>
//       <button
//         onClick={() => setShowConfirmation(true)}
//         className="text-red-500 hover:text-red-600"
//       >
//         <Trash size={16} />
//       </button>

//       {/* Confirmation Modal */}
//       {showConfirmation && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-lg font-semibold text-black">Confirm Deletion</h3>
//               <button 
//                 onClick={() => setShowConfirmation(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <X size={20} />
//               </button>
//             </div>
//             <p className="mb-6 text-black">Are you sure you want to delete this company? This action cannot be undone.</p>
//             <div className="flex justify-end space-x-4">
//               <button
//                 onClick={() => setShowConfirmation(false)}
//                 className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handledelete}
//                 className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default CompanyDeleteButton;






import React, { useState } from 'react';
import { Trash2, X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCompany } from '../../../FeatureRedux/CompanyReducer/deleteCompany';
import { allcompanylist } from '../../../FeatureRedux/CompanyReducer/getCompanylist';

function CompanyDeleteButton({ id }) {
  const dispatch = useDispatch();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { isLoading } = useSelector((state) => state.deleteCompany);

  const handledelete = async () => {
    await dispatch(deleteCompany(id));
    dispatch(allcompanylist());
    setShowConfirmation(false);
  };

  return (
    <div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowConfirmation(true);
        }}
        className="text-red-500 hover:text-red-700"
      >
        <Trash2 className="w-4 h-4" />
      </button>

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-lg p-6 w-full max-w-md transform transition-all border border-gray-700">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-white">Confirm Deletion</h3>
              <button 
                onClick={() => setShowConfirmation(false)}
                className="text-gray-400 hover:text-white"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            <p className="text-gray-300 mb-6">
              Are you sure you want to delete company ? This action cannot be undone.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowConfirmation(false)}
                className="px-4 py-2 rounded-md bg-gray-600 text-white hover:bg-gray-700 transition-colors border border-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handledelete}
                className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 transition-colors flex items-center border border-red-700"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Deleting...
                  </>
                ) : (
                  <>
                    <Trash2 className="w-4 h-4 mr-2" />
                    Delete
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CompanyDeleteButton;